import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Popup, genericTexts, Loader, SortableTable, RadioGroup } from 'hub-web-lib'
import { ACTIVITY } from 'js/constants/vocabulary'
import { connect } from 'react-redux'
import { action } from 'js/actions'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import store from 'js/store'
import EasmApi from 'services/EasmApi'
import { activityColumns } from 'js/constants/table-columns'
import { UpdateEasmActivity } from './ActivityInfo/UpdateActivity/UpdateEasmActivity'
import 'scss/UpdateActivity/UpdateActivity.scss'
import UserApi from 'services/UserApi'
import { getUserRole } from 'js/ui-helpers/roles'
import { getActivityTableData, getSelectedActivity } from 'js/ui-helpers/activity'
import { ACTIVE, ARCHIVED, nonCompleteNotification, starArchive, allOption } from 'js/constants/enums/activity'
import { ACTIVITY_PATH, ATTACK_SURFACE_MODULE, appModulesPaths } from 'js/constants/app-modules'
import 'scss/ActivityManagement.scss'
import { refactorFindings } from 'js/ui-helpers/metrics'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser,
        currentUserOrgs: state.currentUserOrgs
    }
}

export const EasmActivityManagementComponent = ({ currentUser, currentUserOrgs }) => {
    const currentOrgId = currentUser?.current_org
    const [isLoading, setIsLoading] = useState(true)
    const [activities, setActivities] = useState([])
    const [selectedActivityId, setSelectedActivityId] = useState('')
    const [isOpenActivityPopup, setIsOpenActivityPopup] = useState(false)
    const [isNewActivity, setIsNewActivity] = useState(false)
    const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false)
    const [isShowArchived, setIsShowArchived] = useState(false)
    const [currentOrg, setCurrentOrg] = useState(null)
    const [orgUsers, setOrgUsers] = useState([])
    const [templateUrl, setTemplateUrl] = useState('')
    const [filterType, setFilterType] = useState('all')
    const [searchParams] = useSearchParams()
    const [starArray, setStarArray] = useState()
    const providedId = searchParams.get('id')
    const activityColumnsUser = currentUser?.is_admin ? activityColumns : [...activityColumns].filter(c => c.key !== 'organization')
    const navigate = useNavigate()
    const { selectedActivity, selectedActivityTitle } = getSelectedActivity(activities, selectedActivityId)

    const openUpdateActivityPopup = () => {
        setIsNewActivity(true)
        setIsOpenActivityPopup(true)
    }


    const updateActivityStatus = async (activityId, actionType) => {
        const currentActivity = await EasmApi.getActivity(activityId)
        if (!currentActivity || currentActivity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: currentActivity.message, notificationType: 'error' }))
            return
        }
        currentActivity[actionType] = !currentActivity[actionType]
        const updated_activity = await EasmApi.updateActivity(currentActivity)
        if (!updated_activity || updated_activity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: updated_activity.message, notificationType: 'error' }))
            return
        }
    
        await updateActivities()
    }   
    const closeUpdateActivityPopup = () => {
        setIsNewActivity(false)
        setIsOpenActivityPopup(false)
        setSelectedActivityId('')
    }
    const tableData = getActivityTableData(activities, starArray)

    const updateActivities = async (org = currentOrg) => {
        const activities = await EasmApi.getAllActivities(currentOrgId)
        const orgName = org?.name || org?.id || ''
        if (!activities || activities.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: activities.message, notificationType: 'error' }))
            return
        }
        for await (const activity of activities) {
            activity.organization = orgName
            activity.metrics = await EasmApi.getActivityMetrics(activity.id)
            if (!activity.metrics || activity.metrics.error) activity.metrics = []
            activity.findings = []
            if (activity.has_findings) {
                const findings = await EasmApi.getActivityFindings(activity.id)
                if (findings && !findings.error) activity.findings = refactorFindings(findings)
            }
        }
        setActivities(activities)
        const tempStarArray = {}
        activities.map(a => tempStarArray[a.id] = a.starred)
        setStarArray(tempStarArray)   
    }

    const getPermittedUsersList = (users) => {
        return [...users.filter(user => getUserRole(user) < 4)
            .sort((a, b) => a.id * 1 - b.id * 1)
            .map(user => ({ id: user.id, name: user.name || user.user_name }))]
    }


    const getOrgsAndMetrics = async () => {
        const org = currentUserOrgs.find(o => o.id === currentOrgId) || { id: currentOrgId }
        const users = await UserApi.getOrgUsers(currentOrgId)
        setCurrentOrg(org && !org.error ? org : { id: currentOrgId })
        setOrgUsers(users && !users.error ? getPermittedUsersList(users) : [])
        return org
    }

    const getTemplateUrl = async () => {
        const template = await EasmApi.downloadMetricsTemplate()
        setTemplateUrl(template?.url || '')
    }

    const deleteActivity = async () => {
        setIsOpenDeletePopup(false)
        const deletedActiviry = await EasmApi.deleteActivity(selectedActivityId)
        if (!deletedActiviry || deletedActiviry.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedError(ACTIVITY), notificationType: 'error' }))
            return
        }  
        store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedSuccess(ACTIVITY) }))
        await updateActivities()
    }

    const menuClickHandler = async (action, activityId) => {
        setSelectedActivityId(activityId)
        const { selectedActivity } = getSelectedActivity(activities, activityId)
        switch (action) {
        case genericTexts.actionsText.info:
            navigate(`/${appModulesPaths[ATTACK_SURFACE_MODULE]}/${ACTIVITY_PATH}/${activityId}`, { state: { activity: selectedActivity } })
            break
        case genericTexts.actionsText.edit:
            setIsOpenActivityPopup(true)
            setIsNewActivity(false)
            break
        case genericTexts.actionsText.archive:
            updateActivityStatus(activityId, 'archived')
            break
        case genericTexts.actionsText.delete:
            setIsOpenDeletePopup(true)
            break
        }
    }

    const openEditPopup = () => {
        if (!providedId) return
        const { selectedActivity } = getSelectedActivity(activities, providedId)
        if (selectedActivity) {
            if (!selectedActivity.is_complete) store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: nonCompleteNotification, notificationType: 'warning' }))
            setSelectedActivityId(providedId)
            setIsOpenActivityPopup(true)
            setIsNewActivity(false)
        }
    }

    const handleTdClick = (val, activityId) => {
        if (val === 'star') {
            const updatedStarArray = { ...starArray } 
            updatedStarArray[activityId] = !updatedStarArray[activityId] 
            setStarArray(updatedStarArray)
            updateActivityStatus(activityId, 'starred')
            return
        }
        setSelectedActivityId(activityId)
        setIsOpenActivityPopup(true)
        setIsNewActivity(false)
    }

    useEffect( async () => {
        const org = await getOrgsAndMetrics()
        await updateActivities(org)
        openEditPopup()
        setIsLoading(false)
        getTemplateUrl()
    }, [])

    const filterTableData = () => {
        if (isShowArchived) return tableData.filter(item => item.archived)
        return tableData.filter(item => (filterType === allOption.id ? true : item.starred) && !item.archived)
    }

    const filteredTableData = filterTableData()

    return (
        <div className='easm-activities page-content'>
            <div className='page-header'>
                <h1 id='easm-activities-management'>eASM Activities Management</h1>
                {!isLoading && <button onClick={openUpdateActivityPopup} id='add-new-easm-activity'>{genericTexts.defaultText.addNewButton(ACTIVITY)}</button>}
            </div>
            {!!tableData?.length && <div className={`filter-switcher ${filteredTableData.length ? 'has-content' : ''}`}>
                {!isShowArchived && <RadioGroup radioGroupId='filter-switcher-group' checkedId={filterType} isSwitcher={true} updateItem={setFilterType} allItems={ [allOption, starArchive] }/>}
                <div className='archive-button'> 
                    <button className='btn-set' onClick={() => setIsShowArchived(!isShowArchived)}>Show {isShowArchived ? ACTIVE : ARCHIVED}</button>
                </div>
            </div>}
            {isLoading ? <Loader /> : <div className='report-management-con'>
                <SortableTable 
                    columns={activityColumnsUser}
                    tableData={filteredTableData}
                    defaultSort={{ key: 'id' }}
                    menuClickHandler={menuClickHandler}
                    handleTdClick={handleTdClick}
                    tableId='easm-activities-table' />
                {isOpenActivityPopup && <Popup
                    onClose={closeUpdateActivityPopup}
                    isOpen={isOpenActivityPopup}
                    title={isNewActivity ? genericTexts.defaultText.addNewPopupTitle(ACTIVITY) : genericTexts.actionsText.editText(ACTIVITY, true)}
                    isDisabledClickOutside={true}
                    customClass='update-activity update-activity-easm'>
                    <UpdateEasmActivity
                        isNewActivity={isNewActivity}
                        currentOrg={currentOrg}
                        orgUsers={orgUsers}
                        currentUser={currentUser}
                        closeUpdateActivityPopup={closeUpdateActivityPopup}
                        updateActivities={updateActivities}
                        activityDetails={selectedActivity}
                        templateUrl={templateUrl} />
                </Popup>}


            </div>}
            <Popup
                onClose={() => setIsOpenDeletePopup(false)}
                isOpen={isOpenDeletePopup}
                title={genericTexts.defaultText.deletePopupTitle}>
                <p>{genericTexts.defaultText.deletePopupText(`${ACTIVITY} ${selectedActivityTitle}`)}</p>
                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={deleteActivity} id='delete-easm-activity'>{genericTexts.defaultText.yes}</button>
                    <button onClick={() => setIsOpenDeletePopup(false)} className='btn-cancel' id='delete-easm-activity-cancel'>{genericTexts.defaultText.no}</button>
                </div>
            </Popup>
        </div>     
    )
}

const EasmActivityManagement = connect(mapStateToProps)(EasmActivityManagementComponent)

export default EasmActivityManagement